import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SpinnerBox.scss';
import CustomBox from 'components/controls/grid/CustomBox';
import CustomGrid from 'components/controls/grid/CustomGrid';
import Spinner from 'components/controls/Spinner';

export default function SpinnerBox(props) {
    const {overlay, className, fullScreen, ...restProps} = props;

    return (
        <CustomBox
            py="l"
            className={classnames(
                styles.wrapper,
                className,
                {
                    [styles.overlay]: overlay,
                    [styles.fullScreen]: fullScreen,
                }
            )}
            {...restProps}
        >
            <CustomGrid
                container
                justify="center"
                alignItems="center"
                classes={{
                    root: styles.innerWrapper
                }}
            >
                <Spinner />
            </CustomGrid>
        </CustomBox>
    )
}

SpinnerBox.propTypes = {
    overlay: PropTypes.bool,
    className: PropTypes.string,
    fullScreen: PropTypes.bool,
};

SpinnerBox.defaultProps = {
    overlay: false,
    fullScreen: false,
};



// WEBPACK FOOTER //
// ./src/components/controls/SpinnerBox.jsx